import { GET_CITIES_RESULT } from './../types';

export default function cities(state = {}, action = {}) {
    switch (action.type) {
        case GET_CITIES_RESULT:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/cities.js